import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://ylauwhzmjkmyslgbebnc.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlsYXV3aHptamtteXNsZ2JlYm5jIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjE1MTcwOTIsImV4cCI6MjAzNzA5MzA5Mn0.nyu5YYztPK3BfCaAwm6MD7PxYnti3TMD73PGDa4jFu8"

export const supabase = createClient(supabaseUrl, supabaseAnonKey)